import PresetItemInterface from "../../../interfaces/PresetItemInterface";
import PresetInterface from "../../../interfaces/PresetInterface";
import PresetItemCustomFieldInterface from "../../../interfaces/PresetItemCustomFieldInterface";
import GetItemVat from "./GetItemVat";
import moment from "moment"
import "moment/locale/ru"
import GetItemSum from "./GetItemSum";


export interface GetItemValueFunctionParamsInterface {
    preset: PresetInterface,
    item: PresetItemInterface,
    field: {id: number, width: number, name: string},
    customField: Array<PresetItemCustomFieldInterface>,
    index: number,
}

export default function GetItemValue (params: GetItemValueFunctionParamsInterface): number|string {
    let value: number|string = "-"

    if (params.field.id !== 4 && params.customField.length > 0) {
        const customField: PresetItemCustomFieldInterface = params.customField[0]
        switch (customField.type_id) {
            case 2:
            case 20:
                value = parseFloat(params.customField[0].values[0].value).toLocaleString('ru-RU') + (customField.type_id === 20 ? " ₽" : "")
                break
            case 3:
                value = params.customField[0].values[0].value === "1" ? "✓" : "×"
                break
            case 5:
                value = params.customField[0].values.map((value) => {
                    return value.value
                }).join(", ")
                break
            case 6:
                try {
                    value = moment(params.customField[0].values[0].value).locale("ru").format("L")
                } catch (e) {
                    value = "-"
                }
                break
            case 19:
                try {
                    value = moment(params.customField[0].values[0].value).locale("ru").format("L HH:mm")
                } catch (e) {
                    value = "-"
                }
                break
            default:
                value = params.customField[0].values[0].value
                break
        }

    } else {
        if (params.field.id === 3) {
            value = params.index + 1
        }else if (params.field.id === 2) {
            value = GetItemVat(params.preset, params.item)
        }else if (params.field.id === 4) {
            value = GetItemSum(params.preset, params.item)
        }
    }
    return value
}